<script lang="ts">
  import { Col, Container, Image, Row } from "sveltestrap";
  import BookmarkGalleryGrid from "./BookmarkGalleryGrid.svelte";
  import Card from "../../../Core/Card.svelte";
  import { LightboxGallery, GalleryImage, GalleryThumbnail } from 'svelte-lightbox';
  import data from "../../../../Data/Miscellaneous/Gallery.json"
  import { IMAGEGALLERY } from "../../../../utils/Constant/Constant";
  let imgPath:string = "/assets/images"

</script>
<BookmarkGalleryGrid />
<Container fluid>
  <Row>
    <Col sm="12">
      <Card headerTitle={IMAGEGALLERY} cardHeaderprops="pb-0" cardBodyprops="gallery my-gallery row">
        <div slot="contentbody">
            <LightboxGallery>
              <svelte:fragment slot="thumbnail">
                <Row class="sample-class-1">
                  {#each data.src as imgItem}
                    <Col xl="3" sm="6"  class="light-gallery">
                      <GalleryThumbnail>
                        <Image src="{imgPath}/{imgItem}" alt="Simple lightbox" />
                      </GalleryThumbnail>
                    </Col>
                  {/each}
                </Row>
              </svelte:fragment>
              {#each data.src as imgItem}
                <GalleryImage>
                  <Image src="{imgPath}/{imgItem}" alt="Simple lightbox" />
                </GalleryImage>
              {/each}
            </LightboxGallery>
        </div>
      </Card>
    </Col>
  </Row>
</Container>